import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Chatbot from "@/components/Chatbot";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import RestaurantPage from "@/pages/RestaurantPage";
import ContactPage from "@/pages/ContactPage";
import HabitacionesPage from "@/pages/HabitacionesPage";
import GaleriaPage from "@/pages/GaleriaPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout() {
  useScrollReveal();
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Chatbot />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/reservar" element={<BookingPage />} />
          <Route path="/restaurante" element={<RestaurantPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/habitaciones" element={<HabitacionesPage />} />
          <Route path="/galeria" element={<GaleriaPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
